import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId, useFetchUpdate,
} from '../fetch';

interface UserData {
  email?: string;
  name: string;
  yearBirth: number;
  zipCode: string;
  categoryId: string;
  subCategoryId: string;
  countryId: number;
  tipFrequency: 'regularly' | 'sometimes' | 'never';
  tipType: '%' | '$';
  tipValue: number;
}

export interface CountriesData {
  data: Countries[];
  meta: {
    page: number;
    pageSize: number;
    itemCount: number;
    pageCount: number;
    hasNextPage: boolean;
  };
}

export interface Countries extends CountriesParam {
  id: string | number;
}
export interface CountriesParam {
  name: string;
  iso3: string;
}

export interface SubCategoriesData {
  data: SubCategory[];
  meta: {
    page: number;
    pageSize: number;
    itemCount: number;
    pageCount: number;
    hasNextPage: boolean;
  };
}

export interface Category {
  id: string;
  name: string;
  isActive: boolean;
}

export interface SubCategory {
  id: string;
  header: string;
  isActive: boolean;
  description: string | null;
  category: Category;
  displayKeywords: string[];
  searchKeywords: string[];
  workersKeywords: string[];
  occupation: string
}

export interface SubCategoryPost {
  id?: string;
  header: string;
}

export const useCountriesGetAll = (): FetchGet<CountriesData, DefaultFetchError> => (
  useFetchGet('countries?pageSize=300', { multiple: 'country-get', cacheLifetime: 120 * 1000 })
);

export const useCategoriesGetAll = (): FetchGet<SubCategoriesData, DefaultFetchError> => (
  useFetchGet('sub-categories?pageSize=500')
);

// export const useSubCategoriesGetById = (id?: string): FetchGetId<
//   SubCategoriesData,
//  DefaultFetchError,
//   unknown
// > => (
//   useFetchGetId(`sub-categories/${id}`)
// );

export const useSubcategoriesCreate = (): FetchCreate<SubCategory, DefaultFetchError, SubCategoryPost> => (
  useFetchCreate('sub-categories')
);
export const useUserUpdate = (id?: string): FetchUpdate<
  FetchSuccess, DefaultFetchError, UserData> => (
  useFetchUpdate('users?site=user_portal', id)
);

export const useUserUpdateMe = (): FetchUpdate<
  FetchSuccess, DefaultFetchError, UserData> => (
  useFetchUpdate('users?site=user_portal')
);

export const useSubCategoriesGetById = (id?: string): FetchGetId<SubCategory, DefaultFetchError> => (
  useFetchGetId('sub-categories', id)
);

export const useCountriesGet = <DD = { value: string; label: string }[]>(
  decorateData: (data: { name: string; id: string }[]) =>
    DD = (data) => data.map((item) => ({ value: item.id, label: item.name })) as DD,
  autoStart = true,
): FetchGet<
  { data: { name: string; id: string }[]; meta: any },
  undefined,
  DefaultFetchError,
  DD
> => useFetchGet(
    'countries',
    {
      autoStart,
      startStateLoading: autoStart,
      decorateData: (response) => {
        if (Array.isArray(response.data)) {
          return decorateData(response.data);
        }
        console.error('Invalid data format:', response);

        return [] as DD;
      },
    },
  );
